import { Game }        from '@bridge128/bridge128-game-logic-lib';
import { GameState }   from '@bridge128/bridge128-game-logic-lib';
import { DealParser }  from '@bridge128/bridge128-game-logic-lib';

const joinGame = () => {
	console.warn('"joinGame" method is deprecated');
};

const leaveGame = () => {
	console.warn('"leaveGame" method is deprecated');
};

const canClaim = ({ tricks }) => {
	console.warn('"canClaim" method is deprecated');
};

const claimTricks = ({ tricks }) => {
	console.warn('"claimTricks" method is deprecated');
};

const playCardFromDDS = () => {
	console.warn('"playCardFromDDS" method is deprecated');
};

const getNewGameFromGameState = ({ gameState }) => {
	const newGame = Game.fromState(gameState);
	if (!newGame) {
		return false;
	}
	return newGame.currentGameData;
};

const getGameInstanceFromGameState = ({ gameState }) => {
	const newGame = Game.fromState(gameState);
	if (!newGame) {
		return false;
	}
	return newGame;
};

const playCardByName = ({ cardName, gameData }) => {
	const game = DealParser.fromCurrentGameData(gameData);
	const card = game.deck.card(cardName);
	game.playCard(card);
	return game.currentGameData;
};

const addBidByName = ({ bidName, gameData }) => {
	const game = DealParser.fromCurrentGameData(gameData);
	game.addBid(bidName);
	return game.currentGameData;
};

const undo = ({ gameData }) => {
	const game = DealParser.fromCurrentGameData(gameData);
	const gameState = new GameState(game);
	const nextGame = Game.fromState(gameState.undo());
	return nextGame.currentGameData;
};

const undoCard = ({ gameData }) => {
	const game = DealParser.fromCurrentGameData(gameData);
	const gameState = new GameState(game);
	const nextGame = Game.fromState(gameState.stateAtLastCard);
	return nextGame.currentGameData;
};

const undoTrick = ({ gameData }) => {
	const game = DealParser.fromCurrentGameData(gameData);
	const gameState = new GameState(game);
	const nextGame = Game.fromState(gameState.lastTrick);
	return nextGame.currentGameData;
};

const resetToBeginningOfAuction = ({ gameData }) => {
	const game = DealParser.fromCurrentGameData(gameData);
	const gameState = new GameState(game);
	const nextGame = Game.fromState(gameState.stateBeforeAuction);
	return nextGame.currentGameData;
};

const resetToBeginningOfTricks = ({ gameData }) => {
	const game = DealParser.fromCurrentGameData(gameData);
	const gameState = new GameState(game);
	const nextGame = Game.fromState(gameState.stateAtEndOfAuction);
	return nextGame.currentGameData;
};

const enableDDS = ({ gameData }) => {
	const game = DealParser.fromCurrentGameData(gameData);
	game.enableDDS(true);
	return game.currentGameData;
};

const disableDDS = ({ gameData }) => {
	const game = DealParser.fromCurrentGameData(gameData);
	game.disableDDS();
	return game.currentGameData;
};

export default {
	joinGame,
	leaveGame,
	canClaim,
	claimTricks,
	playCardFromDDS,
	getNewGameFromGameState,
	getGameInstanceFromGameState,
	playCardByName,
	addBidByName,
	undo,
	undoCard,
	undoTrick,
	resetToBeginningOfAuction,
	resetToBeginningOfTricks,
	enableDDS,
	disableDDS
};
